import React from "react";
import styled from "styled-components";

const MenuItems = styled.ul`
  position: absolute;
  left: 50%;
  display: inline-block;
  background: white;
  width: 100%;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, .3);
  z-index: 1;
  transform-origin: ${props => props.bottom ? 'bottom' : 'top'};
  top: ${props => props.bottom ? 'inherit' : '-10px'};
  bottom: ${props => props.bottom ? '-10px' : 'inherit'};
  padding: ${props => props.bottom ? '0 0 35px 0' : '35px 0 0 0'};
  transform: translate(-50%, 0) scale(1, ${props => props.open ? '1' : '0'});
  opacity: ${props => props.open ? '1' : '0'};
  transition: opacity .3s, transform .3s;
`;

export default MenuItems;



// WEBPACK FOOTER //
// ./src/styled-components/MenuItems.js